export default __webpack_public_path__ + "static/media/control-devices.b7c89ff4.PNG";